/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.runs.RunStatus
*/
export var RunStatus;
(function (RunStatus) {
    RunStatus["RUNNING"] = "RUNNING";
    RunStatus["WAITING"] = "WAITING";
    RunStatus["PAUSED"] = "PAUSED";
    RunStatus["STOPPING"] = "STOPPING";
    RunStatus["DONE"] = "DONE";
    RunStatus["FAILED"] = "FAILED";
    RunStatus["STOPPED"] = "STOPPED";
})(RunStatus || (RunStatus = {}));
//# sourceMappingURL=RunStatus.js.map